import LoginForm from '../features/Auth/LoginForm';

const LoginPage = () => {
  return <LoginForm />;
};

export default LoginPage; 